import { FC } from "react";
import styles from "./Tracked.module.scss";
import cn from "classnames";
import Modal from "@components/shared/modals/Modal";
import ModalContent from "@components/shared/modals/Modal/ModalContent";
import { useModal } from "@hooks/useModal";
import { shortWallet } from "@utils/shortWallet";

interface Props {
    isModalVisible: boolean;
    setIsModalVisible(value: boolean): void;
    setSelectedWallet(value: string): void;
}

const Tracked: FC<Props> = ({ isModalVisible, setIsModalVisible, setSelectedWallet }) => {
    const [_, handleHide] = useModal(setIsModalVisible);

    const handleSelectWallet = (value: string) => {
        setSelectedWallet(value);
        handleHide();
    };

    const wallets = [
        {
            title: "Mega whale",
            value: "UQDmFdfsd66JX8H",
        },
        {
            title: "Mega whale",
            value: "QwrUF4f5Fkls",
        },
        {
            title: "Mega whale",
            value: "UQDmFdf4dfF6JX8H",
        },
        {
            title: "Mega whale",
            value: "QwrUF4fiFkls",
        },
        {
            title: "Mega whale",
            value: "UQ3FdfsdfF6JX8H",
        },
        {
            title: "Mega whale",
            value: "QwrUF4fiF1kls",
        },
        {
            title: "Mega whale",
            value: "QwrUF4f43iFkls",
        },
    ];

    return (
        <Modal isVisible={isModalVisible} setIsVisible={setIsModalVisible}>
            <ModalContent classNames={cn(styles.modal, styles.wallet)}>
                <div className={styles.modalHeader}>
                    <h2>Select a tracked wallet</h2>
                    <button className={styles.close} onClick={handleHide}>
                        <picture>
                            <source
                                srcSet="/images/modal/closemobile.svg"
                                width={7.5}
                                height={7.5}
                                media="(max-width: 768px)"
                            />
                            <img
                                height={12}
                                width={12}
                                src="/images/modal/close.svg"
                                style={{ opacity: 0.4 }}
                                alt="Close modal"
                            />
                        </picture>
                    </button>
                </div>
                <div className={styles.modalItems}>
                    {wallets.map(({ title, value: wallet }) => (
                        <div key={wallet} className={styles.modalItemHolder}>
                            <button onClick={() => handleSelectWallet(wallet)} className={styles.modalItem}>
                                <div className={styles.modalText}>
                                    <h3 className={styles.modalTitle}>{title}</h3>
                                    <p className={styles.modalWallet}>{shortWallet(wallet)}</p>
                                </div>
                            </button>

                            <button className={styles.modalTrash}>
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <desc>Delete wallet</desc>
                                    <path
                                        d="M21.07 5.23C19.46 5.07 17.85 4.95 16.23 4.86V4.85L16.01 3.55C15.86 2.63 15.64 1.25 13.3 1.25H10.68C8.34997 1.25 8.12997 2.57 7.96997 3.54L7.75997 4.82C6.82997 4.88 5.89997 4.94 4.96997 5.03L2.92997 5.23C2.50997 5.27 2.20997 5.64 2.24997 6.05C2.28997 6.46 2.64997 6.76 3.06997 6.72L5.10997 6.52C10.35 6 15.63 6.2 20.93 6.73C20.96 6.73 20.98 6.73 21.01 6.73C21.39 6.73 21.72 6.44 21.76 6.05C21.79 5.64 21.49 5.27 21.07 5.23Z"
                                        fill="white"
                                        fillOpacity="0.5"
                                    />
                                    <path
                                        opacity="0.3991"
                                        d="M19.23 8.14C18.99 7.89 18.66 7.75 18.32 7.75H5.67999C5.33999 7.75 4.99999 7.89 4.76999 8.14C4.53999 8.39 4.40999 8.73 4.42999 9.08L5.04999 19.34C5.15999 20.86 5.29999 22.76 8.78999 22.76H15.21C18.7 22.76 18.84 20.87 18.95 19.34L19.57 9.09C19.59 8.73 19.46 8.39 19.23 8.14Z"
                                        fill="white"
                                        fillOpacity="0.5"
                                    />
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M9.58002 17C9.58002 16.5858 9.9158 16.25 10.33 16.25H13.66C14.0742 16.25 14.41 16.5858 14.41 17C14.41 17.4142 14.0742 17.75 13.66 17.75H10.33C9.9158 17.75 9.58002 17.4142 9.58002 17Z"
                                        fill="white"
                                        fillOpacity="0.5"
                                    />
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M8.75 13C8.75 12.5858 9.08579 12.25 9.5 12.25H14.5C14.9142 12.25 15.25 12.5858 15.25 13C15.25 13.4142 14.9142 13.75 14.5 13.75H9.5C9.08579 13.75 8.75 13.4142 8.75 13Z"
                                        fill="white"
                                        fillOpacity="0.5"
                                    />
                                </svg>
                            </button>
                        </div>
                    ))}
                </div>
            </ModalContent>
        </Modal>
    );
};

export default Tracked;
